import { render, staticRenderFns } from "./dashboardTijianjigoufeiyong.vue?vue&type=template&id=50cf18c6&scoped=true"
import script from "./dashboardTijianjigoufeiyong.vue?vue&type=script&lang=js"
export * from "./dashboardTijianjigoufeiyong.vue?vue&type=script&lang=js"
import style0 from "./dashboardTijianjigoufeiyong.vue?vue&type=style&index=0&id=50cf18c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf18c6",
  null
  
)

export default component.exports